import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { AuthSyncService } from './core/auth/auth-sync.service'
import { ShortcutCheatSheetComponent } from './core/keyboard/shortcut-cheat-sheet.component'
import { CheckIdleService } from './services/check-idle.service'
import { ThemeService } from './services/theme.service'

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, ShortcutCheatSheetComponent],
    templateUrl: './app.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.scss'
})
export class App implements OnInit {
    constructor (
        private themeService: ThemeService,
        public ts: TranslateService,
        private checkIdleService: CheckIdleService,
        private authSync: AuthSyncService
    ) {
        ts.addLangs(['en', 'fr'])
        const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') as string : ts.getBrowserLang()
        ts.use(lang as string)
    }

    ngOnInit () {
        const myTheme = this.themeService.getTheme()
        this.themeService.setTheme(myTheme)
        this.checkIdleService.startWatching()
        this.authSync.start()
    }

    @HostListener('window:blur')
    onBlur (): void {
    }

    @HostListener('window:focus')
    onFocus () {
    }

    @HostListener('window:visibilitychange')
    onVisibilityChange () {
    }
}
